import { CSS_VARIABLES } from "enums/cssVariables";
import styled from "styled-components";

export const BaseOptionButton = styled.button`
    width: 100%;
    display: block;
    background: #ffffff;
    border: 1px solid grey;
    margin-bottom: 0.75rem;
    min-height: 2.75rem;
    word-wrap: break-word;
    font-size: 14px;
    :hover {
        cursor: pointer;
    }
    :focus-visible {
        outline: solid 3px var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
    }
`;
